import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ImagePlayerComponent} from '@app/player/image-player.component';
import {layoutClasses} from '@app/player/layout/layout-classes';
import {HtmlOverlayLayoutComponent} from '@app/player/layout/html-overlay-layout.component';
import {PlaylistPlayerComponent} from '@app/player/playlist-player.component';
import {LAYOUT_CLASSES_TOKEN} from '@app/player/playlist-player.component.base';
import {VideoPlayerComponent} from '@app/player/video-player.component';
import {VideoTagPlayerComponent} from '@app/player/video-tag-player.component';

@NgModule({
    imports: [
        CommonModule,
    ],
    declarations: [
        HtmlOverlayLayoutComponent,
        ImagePlayerComponent,
        PlaylistPlayerComponent,
        VideoPlayerComponent,
        VideoTagPlayerComponent,
    ],
    exports: [
        HtmlOverlayLayoutComponent,
        ImagePlayerComponent,
        PlaylistPlayerComponent,
    ],
    entryComponents: [
        // We need all layouts to be defined as entryComponents because they are instantiated dynamically
        HtmlOverlayLayoutComponent,
    ],
    providers: [
        {provide: LAYOUT_CLASSES_TOKEN, useValue: layoutClasses},
    ],
})
export class PlayerModule {
}
